import React from 'react';
import './CartDisclaimer.less';

export const CartDisclaimer = ({text}) => {
	return (
		<div className="cart-disclaimer">{text}</div>
	);
};
